import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { useLocale } from '@/modules/locale/model/locale';
import { itemService } from '@/services/item';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useItemTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { systemLocaleSupported } = useLocale();

    const model = reactive({
        id: route.params.itemId,
        locale: null,
        title: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await systemLocaleSupported.load();
        if (!systemLocaleSupported.model.hasData) {
            router.push({ name: ROUTE_NAME_ITEM.SYSTEM.INDEX });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => itemService.text.get(model.id, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => itemService.text.update(model.id, model.locale, model.title),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => itemService.text.remove(model.id, model.locale),
            onSuccess: fetch
        })
    };

    onMounted(async () => {
        await beforeFetch();
        await fetch();
    });

    return { model, v$, fetch, actions, systemLocaleSupported };
}
